package org.example.zone360.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onFocusIn
import com.varabyte.kobweb.compose.ui.modifiers.onKeyDown
import com.varabyte.kobweb.compose.ui.modifiers.onKeyUp
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaCircleXmark
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.launch
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Res
import org.example.zone360.utils.ToastID
import org.example.zone360.utils.extractTeamName
import org.example.zone360.utils.noBorder
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.CSSLengthOrPercentageValue
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Input
import org.w3c.dom.Element
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.events.EventListener
import org.example.zone360.utils.updateUserWithTeam

@Composable
fun TokenSearch(
    data: List<String>,
    width: CSSLengthOrPercentageValue  = 350.px,
    selectedData: MutableList<String>,
    onSelected: (String) -> Unit,
    onRemoved: (String) -> Unit,
    searchInputId: String = "team_search",
    placeholder: String = "",
    openUpward: Boolean = false,
    disableDropdownIfSelected: Boolean = false
) {
    var showDropdown by remember { mutableStateOf(false) }
    var filteredData by remember { mutableStateOf(data) }
    var isHover by remember { mutableStateOf(false) }
    val sitePalette = ColorMode.current.toSitePalette()

    DisposableEffect(showDropdown) {
        val listener = EventListener { event ->
            if (showDropdown) {
                val target = event.target as? Element
                if (target != null && target.closest(".services-dropdown") == null) {
                    showDropdown = false
                }
            }
        }
        window.addEventListener("click", listener)
        onDispose { window.removeEventListener("click", listener) }
    }

    Box(modifier = Modifier.fillMaxWidth(width).position(Position.Relative).classNames("services-dropdown")) {
        Row(
            modifier = Modifier
                .fillMaxWidth(width)
                .minHeight(40.px)
                .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .borderRadius(5.px)
                .border(1.px, style = LineStyle.Solid, color = sitePalette.textFieldBorderColor.rgb)
                .padding(8.px)
                .overflow(overflow = Overflow.Auto)
                .flexWrap(FlexWrap.Wrap)
                .gap(7.px)
                .alignItems(AlignItems.Center),
            verticalAlignment = Alignment.CenterVertically
        ) {
            selectedData.forEach { team ->
                Row(
                    modifier = Modifier
                        .gap(4.px)
                        .height(28.px)
                        .backgroundColor(sitePalette.textFieldBorderColor.rgb)
                        .borderRadius(4.px)
                        .padding(6.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    FieldTitleTextNormalSimple(team, fontSize = 12.px)
                    Image(
                        src = Res.Images.cross_Icon,
                        modifier = Modifier.onClick { onRemoved(team) }
                            .cursor(Cursor.Pointer)
                    )
                }
            }
            Input(
                type = InputType.Text,
                attrs = Modifier
                    .width(100.px)
                    .height(32.px)
                    .backgroundColor(Colors.Transparent)
                    .noBorder()
                    .fontSize(13.px)
                    .classNames("dropdown-trigger")
                    .onFocusIn {
                        if (disableDropdownIfSelected && selectedData.size >= 1) {
                            showDropdown = false
                            filteredData = emptyList()
                            return@onFocusIn
                        }
                        showDropdown = true
                        filteredData = data.filterNot { selectedData.contains(it) }
                    }
                    .onKeyUp {
                        val searchText = (document.getElementById(searchInputId) as HTMLInputElement).value

                        if (disableDropdownIfSelected && selectedData.size >= 1) {
                            filteredData = emptyList()
                            showDropdown = false
                            return@onKeyUp
                        }

                        filteredData = if (searchText.isNotEmpty()) {
                            data.filter { it.contains(searchText, ignoreCase = true) }
                                .filterNot { selectedData.contains(it) }
                        } else {
                            emptyList()
                        }

                        showDropdown = searchText.isNotEmpty()
                    }
                    .toAttrs {
                        id(searchInputId)
                        attr("autocomplete", "off")
                        attr("placeholder", if (selectedData.isEmpty()) placeholder else "")
                    }
            )
        }

        if (showDropdown && filteredData.isNotEmpty()) {
            Box(
                modifier = Modifier
                    .width(width)
                    .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                    .borderRadius(8.px)
                    .border(1.px, style = LineStyle.Solid, color = sitePalette.coachDetailsBoxBorder.rgb)
                    .position(Position.Absolute)
                    .run {
                        if (openUpward) {
                            bottom(50.px)
                        } else {
                            top(50.px)
                        }
                    }
                    .zIndex(999)
                    .maxHeight(200.px)
                    .overflow(Overflow.Auto)
            ) {
                Column {
                    filteredData.forEach { team ->
                        Box(
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(8.px)
                                .cursor(Cursor.Pointer)
                                .onMouseEnter { isHover = true }
                                .onClick {
                                    onSelected(team)
                                    (document.getElementById(searchInputId) as HTMLInputElement).value = ""
                                    showDropdown = false
                                }
                        ) {
                            FieldTitleTextNormalSimple(team,
                                fontSize = 14.px,
                                isClickable = true)
                        }
                    }
                }
            }
        }
    }
}

@Composable
fun TeamTokenSearchForInfo(
    teams: List<String>,
    width: CSSLengthOrPercentageValue = 150.px,
    selectedTeams: MutableList<String>,
    onTeamSelected: (String) -> Unit,
    onTeamRemoved: (String) -> Unit,
    searchInputId: String = "team_search",
    onDismiss: () -> Unit,
    userID: String,
    toastMessage: (String) -> Unit
) {
    var showDropdown by remember { mutableStateOf(false) }
    var filteredTeams by remember { mutableStateOf(teams) }
    val coroutineScope = rememberCoroutineScope()
    val sitePalette = ColorMode.current.toSitePalette()

    DisposableEffect(showDropdown) {
        val listener = EventListener { event ->
            if (showDropdown) {
                val target = event.target as? Element
                if (target != null && target.closest(".services-dropdown") == null) {
                    showDropdown = false
                }
            }
        }
        window.addEventListener("click", listener)
        onDispose { window.removeEventListener("click", listener) }
    }

    Box(modifier = Modifier.position(Position.Relative).classNames("services-dropdown")) {
        Row(
            modifier = Modifier
                .minWidth(width)
                .maxHeight(100.px) // Reduced height
                .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .borderRadius(5.px)
                .border(1.px, style = LineStyle.Solid, color = sitePalette.textFieldBorderColor.rgb)
                .padding(8.px)
                .overflow(Overflow.Auto)
                .flexWrap(FlexWrap.Wrap)
                .gap(7.px)
                .alignItems(AlignItems.Center),
            verticalAlignment = Alignment.CenterVertically
        ) {
            selectedTeams.forEach { team ->
                Row(
                    modifier = Modifier
                        .gap(4.px)
//                        .height(28.px)
                        .backgroundColor(sitePalette.textFieldBorderColor.rgb)
                        .borderRadius(4.px)
                        .padding(6.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    FieldTitleTextNormalSimple(team.extractTeamName(), fontSize = 12.px)
                    FaCircleXmark(
                        style = IconStyle.FILLED,
                        modifier = Modifier
                            .cursor(Cursor.Pointer)
                            .color(sitePalette.primary.rgb)
                            // Removing
                            .onClick {
                                coroutineScope.launch {
                                    // 1. Remove immediately
                                    selectedTeams.remove(team)
                                    onTeamRemoved(team)
                                    toastMessage("Team removed successfully!")
                                    showToast(ToastID.SUCCESS)

                                    // 2. Hit API in background
                                    try {
                                        val response = updateUserWithTeam(
                                            team,
                                            userID,
                                            AppGlobal.userData.organization,
                                            isRemove = true
                                        )
                                        if (response.data != "Team removed successfully!") {
                                            // Revert
                                            selectedTeams.add(team)
                                            onTeamRemoved(team)
                                            toastMessage("Failed to remove team")
                                            showToast(ToastID.ERROR)
                                        }
                                    } catch (_: Exception) {
                                        // Revert
                                        selectedTeams.add(team)
                                        toastMessage("Failed to remove team")
                                        showToast(ToastID.ERROR)
                                    }
                                }
                            }
                    )
                }
            }
            Input(
                type = InputType.Text,
                attrs = Modifier
                    .width(100.px)
                    .height(28.px) // Reduced height
                    .backgroundColor(Colors.Transparent)
                    .classNames("dropdown-trigger")
                    .noBorder()
                    .onKeyDown {
                        if (it.key == "Enter") {
                            onDismiss()
                        }
                    }
                    .onKeyDown {
                        if (it.key == "Enter") {
                            showDropdown = true
                            filteredTeams = teams
                        }
                    }
                    .onFocusIn {
                            showDropdown = true
                            filteredTeams = teams
                           it.stopPropagation() }
                    .onKeyUp {
                        val searchText = (document.getElementById(searchInputId) as HTMLInputElement).value
                        filteredTeams = if (searchText.isNotEmpty()) {
                            teams.filter { it.contains(searchText, ignoreCase = true) }
                                .filterNot { selectedTeams.contains(it) }
                        } else {
                            emptyList()
                        }
                        showDropdown = searchText.isNotEmpty()
                    }
                    .toAttrs {
                        id(searchInputId)
                        attr("autocomplete", "off")
                        attr("placeholder", if (selectedTeams.isEmpty()) "Search teams" else "")
                    }
            )
        }


        if (showDropdown && filteredTeams.isNotEmpty()) {
            Box(
                modifier = Modifier
                    .minWidth(width)
                    .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                    .borderRadius(8.px)
                    .border(1.px, style = LineStyle.Solid, color = sitePalette.coachDetailsBoxBorder.rgb)
                    .position(Position.Absolute)
                    .top(50.px)
                    .zIndex(999)
                    .maxHeight(210.px)
                    .overflow(Overflow.Auto)
            ) {
                Column {
                    filteredTeams.forEach { team ->
                        Box(
                            modifier = Modifier
                                .fillMaxWidth()
                                .padding(8.px)
                                .cursor(Cursor.Pointer)
                                // Adding
                                .onClick {
                                    coroutineScope.launch {
                                        // 1. Update immediately
                                        if (!selectedTeams.contains(team)) {
                                            selectedTeams.add(team)
                                            onTeamSelected(team)
                                            toastMessage("Team updated successfully!")
                                            showToast(ToastID.SUCCESS)
                                            (document.getElementById(searchInputId) as HTMLInputElement).value = ""
                                            showDropdown = false

                                            toastMessage("Team updated successfully!")
                                            showToast(ToastID.SUCCESS)

                                        }
                                        // 2. Hit API in background
                                        try {
                                            val response = updateUserWithTeam(
                                                teamName = team,
                                                userID = userID,
                                                organization = AppGlobal.userData.organization,
                                                isRemove = false
                                            )
                                            if (response.data != "Team updated successfully!") {
                                                // Revert
                                                selectedTeams.remove(team)
                                                onTeamRemoved(team)
                                                toastMessage("Failed to add team")
                                                showToast(ToastID.ERROR)
                                            }
                                        } catch (_: Exception) {
                                            // Revert
                                            selectedTeams.remove(team)
                                            onTeamRemoved(team)
                                            toastMessage("Failed to add team")
                                            showToast(ToastID.ERROR)
                                        }
                                    }
                                }
                        ) {
                            FieldTitleTextNormalSimple(team.extractTeamName(), fontSize = 14.px, isClickable = true)
                        }
                    }
                }
            }
        }
    }
}


